/**
 * Created on 2017/07/11.
 * Controller for 我的账户-账单和余额菜单的结算单
 */
define('controllers/myaccount/settlement/account-new-settlement.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('AccountNewSettlementCtrl', ['$q', '$scope', '$state', 'OpenTrade', 'auiDialog', 'ngDialog', 'UserInfo', 'modBussService',
        'UserInfoPreload', '$filter', 'auiSettlementService', '$rootScope', 'OpenUp', 'payService', 'tenantsService','myIncentiveService','$stateParams',
        function ($q, $scope, $state, OpenTrade, auiDialog, ngDialog, UserInfo, modBussService, UserInfoPreload, $filter,
                  auiSettlementService, $rootScope, OpenUp, payService, tenantsService,myIncentiveService, $stateParams) {
            /* 1. 局部变量声明 */

            // 接收华为云传递过来的特定账单
            var billnoParam = $stateParams.billno;
            var startTimeParam = $stateParams.startTime;
            var endTimeParam = $stateParams.endTime;

            //判断是收益还是余额
            var states = $state.current.name.split('.');
            var state = states[1];
            var billTypes = {
                newEarnings: 'AP',//应付-收益
                bills: 'AR' //应收-账单
            };

            var Model = $scope.Model = {
                billType: billTypes[state],  // 收益还是余额
                cpName: UserInfo.get().realName, //商户名称
                checked: {all: false}, //页面多选框，默认全不选
                modifyList: [], //被选中的关键词数组
                billList: null,
                isShowSelfBilling: mainCons.settlementConstant.showSelfBilling[billTypes[state]]
            };

            var  timeQuarter;
            // 如果有时间范围，则使用自定义时间范围,时间格式是yyyyMM
            if (startTimeParam && endTimeParam && startTimeParam.length == 6 && endTimeParam.length == 6){
                timeQuarter = myIncentiveService.getTimeQuarter(0, 0);
                timeQuarter.startTime = AUI.DateUtil.stringToDate(startTimeParam.slice(0,4) + "-" + startTimeParam.slice(4,6) + "-01");
                timeQuarter.endTime = AUI.DateUtil.stringToDate(endTimeParam.slice(0,4) + "-" + endTimeParam.slice(4,6) + "-01");
            }else{
                timeQuarter = myIncentiveService.getTimeQuarter(12);
            }

            Model.timeQuarter = angular.copy(timeQuarter);


            $rootScope.checkState($state).then(function () {
                reset();
                if (Model.billType == 'AP') {
                    tenantsService.isBankVoid().then(function (isMerchant) {
                        if (!isMerchant) {
                            auiDialog.warn('您的商户服务还未开通或者还处于审核中，如果有疑问请联系客服。', function () {
                                $state.go('mysetting.modBussnessInfo', {}, {reload: true});
                                $rootScope.getBussServiceAgreement = false;
                            });
                        } else {
                            init();
                        }
                    });
                } else {
                    init();
                }

            });

            /* 2. $scope变量声明 */


            // $rootScope也可以通过$on订阅从$rootScope.$broadcast发布的事件
            $rootScope.$on("modifyList", function (event, data) {
                Model.modifyList = data.modifyList;
                Model.checked = data.checked;
            });

            Model.constant = mainCons.settlementConstant;
            Model.businessSelector = [];
            Model.constant.businessSelector[Model.billType].forEach(function(data){
                if(data.typeCode != '204' && data.typeCode != '208' && data.typeCode != '155' && data.typeCode != '156'&& data.typeCode != '157'&& data.typeCode != '158' ){
                    Model.businessSelector.push(data)
                }
            });

            Model.pagination = {
                currentPage: 1,// 当前页
                itemsPerPage: 10,// 默认每页个数
                itemsPerPageBackUp: 10,
                totalCount: 0,
                noItems: "No products",
                pagesLength: 5,// 显示的页码数量,
                onChange: pageChangeDownload,
                bankInfoCN: {},
                bankInfoEN: {}
            };


            /* 3. $scope函数挂载 */

            // 确认结算单
            $scope.confirmSettlement = confirmSettlement;
            //申请争议
            $scope.applyDispute = applyDispute;
            //设置半选的状态
            $scope.checkHalf = checkHalf;
            // 全选否定关键词
            $scope.selectAll = selectAll;

            $scope.selectSingle = selectSingle;

            $scope.queryList = queryList;

            // 下载结算单、明细
            $scope.downloadBill = myIncentiveService.downloadBill;

            // 查看发票
            $scope.displaySelfBilling = myIncentiveService.displaySelfBilling;

            // 重置按钮
            $scope.reset = reset;

            $scope.gotoPayment =gotoPayment;


            /* 4. 初始化函数声明与执行 */

            //防止多次收益结算单多次弹框
            $rootScope.getBussServiceAgreement = true;
            // cp如果没有签订商户服务就访问收益菜单要引导cp签署商户服务 收益时候才判断



            function init() {
                //如果是从确认结算单或者对账明细跳到收益结算单，则按照上次的查询条件进行查询
                if ($rootScope.isGet) {
                    getQuery();
                }

                // 如果有billnoParam则使用billnoParam参数，支持华为云跳转过来
                if (billnoParam){
                    Model.query.billID = billnoParam;
                }

                // 获取开发者信息和商户信息的审核状态
                UserInfo.updateCache(function (userInfo) {
                    if (getAudiState(userInfo)) {
                        $scope.cpInfoIsAuditing = true;
                        Model.content = '开发者信息正在审核中，请耐心等待';
                    }
                });

                modBussService.getBussinesInfo('00011111111111', function (resp) {
                    Model.userInfo = angular.copy(resp);
                    Model.developerInfo = angular.copy(resp.developerInfo);
                });

                // 收益(AP)确认结算单需要开发者信息&商户信息完善且不在审核  账单(AR)需要开发者信息不在审核中
                if (Model.billType == 'AP') {
                    queryList();
                    // 获取商户信息的审核状态
                    modBussService.getBussinesInfo('00010001001', function (resp) {
                        // 用户的银行信息
                        if (resp.bankInfoCN) {
                            Model.bankInfoCN = angular.copy(resp.bankInfoCN);
                        }
                        if (resp.bankInfoEN) {
                            Model.bankInfoEN = angular.copy(resp.bankInfoEN);
                        }

                        if ((resp.bankInfoCN && Model.bankInfoCN.verifyBankState == 1 && resp.bankInfoEN && Model.bankInfoEN.verifyBankState != 2) ||
                            (resp.bankInfoEN && Model.bankInfoEN.verifyBankState == 1 && resp.bankInfoCN && Model.bankInfoCN.verifyBankState != 2)) {
                            $scope.businessInfoIsAuditing = true;
                            Model.content = '您提交的银行信息在审核中，请耐心等待';
                        }
                    });
                } else {//账单需要判断付费服务信息是否完善
                    $scope.businessInfoIsAuditing = false;

                    // 账单菜单的显示要查custumerCode,没有就不显示
                    payService.isPayable().then(function (payable) {
                        if (payable) {
                            queryList();
                        } else {
                            //检查是否付费信息维护提醒，则跳转到签署页面,付费认证状态，0:待完善1:审核中2:审核通过3:已驳回，默认为0
                            auiDialog.payCertifyWarn('发票信息维护提醒', "根据（国家税务总局公告2017年第16号）规定要求，您的发票信息需要更新后才能正常使用付费服务。感谢您的支持。",
                                function () {
                                    //设置标识，表明是从我的账户跳转过去的
                                    $rootScope.isBlance = true;
                                    $state.go('mysetting.payService.modInvoice', {}, {reload: true});
                                });
                        }

                    });
                }
            }


            function queryList() {
                var defer = $q.defer();
                // Model.billList = null;
                detailAllParam(Model.query);

                //保存查询条件
                saveQuery();

                OpenTrade.getSettlement({req: Model.query}).then(function (resp) {
                    resp = typeof resp == 'string' ? JSON.parse(resp) : resp;
                    // 调用成功
                    if (resp.retCode == $filter('auiErrorCode')('success', resp.serviceName)) {
                        if (resp.billInfos) {
                            Model.list = resp.billInfos;
                            Model.pagination.totalCount = Model.list.length;
                            Model.pagination.currentPage = 1;
                            Model.pagination.itemsPerPage = Model.pagination.itemsPerPageBackUp;

                            //根据结算单结束时间倒序排列
                            Model.list.sort(sortByField('endTime'));

                            pageChangeDownload();
                        }
                    }
                    // 全选批量确认结算单按钮是否可以点击
                    Model.unavaliable = !auiSettlementService.checkList(Model.billList, Model.billType);
                    // 之前已选中的结算单清空
                    Model.checked = {all: false};
                    Model.modifyList = [];
                    defer.resolve();
                }).catch(function () {
                    Model.billList = [];
                    // 全选批量确认结算单按钮是否可以点击
                    Model.unavaliable = !auiSettlementService.checkList(Model.billList, Model.billType);
                    // 之前已选中的结算单清空
                    Model.modifyList = [];
                    Model.checked = {all: false};
                    defer.reject();
                });
                return defer.promise;
            }

            //到支付页面
            function gotoPayment(bill) {
                if(bill.businessType === '202' || (bill.appClass==="C20010032" && bill.businessType==='8')){
                    if(bill.startTime>202012 && bill.endTime>202012){
                        myIncentiveService.downloadBill(bill,'sale');
                    }else{
                        auiDialog.warn('教育中心2020年12月前（包括12月）的订单明细因系统原因无法提供下载，请您见谅。');
                    }

                }else if(bill.businessType === '211'){
                    myIncentiveService.downShopBill(bill);
                } else {
                    $state.go('myReport.payment', {startDate:bill.startTime,endDate:bill.endTime}, {reload: true});
                }
            }

            /**
             * 这里做前台分页，不需要重新查询一次接口
             */
            function pageChangeDownload() {
                var result = auiSettlementService.pagination(Model.list, Model.pagination, true);
                Model.billList = result.listForShow;
                // 只有待确认的结算单的多选框才可以点击
                Model.unavaliable = !auiSettlementService.checkList(Model.billList, Model.billType);
                // // 之前已选择的数据清空
                Model.checked = {all: false};
                Model.modifyList = [];
            }

            //根据指定字段名倒序排列数组
            function sortByField(field) {
                return function (o, p) {
                    var a, b;
                    if (typeof o === "object" && typeof p === "object" && o && p) {
                        a = o[field];
                        b = p[field];
                        if (a === b) {
                            return 0;
                        }
                        if (typeof a === typeof b) {
                            return a < b ? 1 : -1;
                        }
                        return typeof a < typeof b ? -1 : 1;
                    }
                }
            }

            /**
             * 将不需要的参数删掉，比如-1
             */
            function detailAllParam() {
                // 结算单时间
                Model.query.queryTime = {
                    startTime: AUI.DateUtil.getyyyymm(Model.timeQuarter.startTime),
                    endTime: AUI.DateUtil.getyyyymm(Model.timeQuarter.endTime)
                };
                // 结算单业务类型
                Model.query.businessType = Model.selector.businessTypeSelector.typeCode;
                if(Model.query.businessType == '4'){
                    Model.query.businessType = '4,204';
                } else if(Model.query.businessType == '8'){
                    Model.query.businessType = '8,208';
                }else if(Model.query.businessType == '55'){
                    Model.query.businessType = '55,155,156,157,158';
                }else if(Model.query.businessType == '118' || Model.query.businessType == '168') {
                    Model.query.businessType = '118,168';
                }
                // 结算单状态
                Model.query.billStatus = Model.selector.billStatusSelector.statusCode;

                for (var attr in Model.query) {
                    if (Object.prototype.hasOwnProperty.call(Model.query,attr) && (!AUI.BaseJSUtil.existy(Model.query[attr]) || Model.query[attr] == '-1')) {
                        delete Model.query[attr];
                    }

                }
            }



            function reset() {
                Model.selector = {
                    billStatusSelector: {
                        statusName: "全部",
                        statusCode: ['developer']
                    }, //结算单状态下拉框默认值
                    businessTypeSelector: {
                        typeName: "全部",
                        typeCode: "-1"
                    }//业务类型下拉框默认值
                };

                Model.query = {
                    billID: '',//结算单号
                    batchNo:'',//申付单号
                    queryTime: {
                        startTime: '',// getLatestMonth()
                        endTime: ''
                    },
                    billStatus: [], //结算单状态
                    businessType: '',//业务类型
                    billType: Model.billType //应收AR 应付AP
                };

                Model.timeQuarter = angular.copy(timeQuarter);
            }


            function confirmSettlement(multiple) {
                var defer = $q.defer();
                if (checkHalf() == 'disabled' || Model.billList.length == 0) {
                    return;
                }
                // 不是批量操作的话把选择那条放到操作数组里
                if (multiple !== 'multiple') {
                    Model.modifyList.splice(0, Model.modifyList.length);
                    Model.modifyList.push(multiple);
                }

                // 是否选择结算单
                if (Model.modifyList.length !== 0) {
                    // 账单结算单直接弹框确认
                    var param = [];
                    if (Model.billType == 'AR') {

                        var confirmBillStatus = 'C020';

                        Model.modifyList.forEach(function (t) {
                            param.push({billID: t.billID, invStat: confirmBillStatus,siteCode:t.siteCode});
                        });

                        auiDialog.confirm('请确认结算单信息是否正确？', function () {
                            OpenTrade.confirmSettlement({
                                req: {
                                    billIDs: param,
                                    confirmType: "账单确认"
                                }
                            }).then(function (resp) {
                                resp = typeof resp == 'string' ? JSON.parse(resp) : resp;
                                if (resp.retCode == $filter('auiErrorCode')('success', resp.serviceName)) {
                                    auiDialog.success('申请结算成功。', function () {
                                        queryList();
                                        defer.resolve();
                                    });
                                }
                            }).catch(function () {
                                queryList();
                                defer.reject();
                            });
                            return defer.promise;
                        }, function () {
                            Model.modifyList = [];
                            Model.checked = {all: false};
                            defer.resolve();
                        });
                    }

                    // 收益合并确认结算单
                    if (Model.billType == 'AP') {
                        if (multiple == 'multiple') {
                            // 收益合并结算单必须相同币种、业务类型、签约主体
                            var i = 0;
                            var businessType = Model.modifyList[0].businessType;
                            var currencyType = Model.modifyList[0].currencyType;
                            var signEntityCode = Model.modifyList[0].signEntityCode;
                            //付款赎期码
                            var rPCode = Model.modifyList[0].rPCode;
                            var sameType = true;
                            for (i = 1; i < Model.modifyList.length; i++) {
                                if (businessType != Model.modifyList[i].businessType
                                    || currencyType != Model.modifyList[i].currencyType
                                    || signEntityCode != Model.modifyList[i].signEntityCode
                                    || rPCode != Model.modifyList[i].rPCode) {
                                    sameType = false;
                                    break;
                                }
                            }
                            if (sameType) {
                                inCurrencyList(Model.modifyList[0], {
                                    cb: function () {
                                        auiSettlementService.confirmSettlementToOpenTrade(Model.modifyList, Model.billType, function () {
                                            //不刷新可以重复点击确认
                                            queryList();
                                            defer.resolve();
                                        }, true, Model.userInfo);
                                    },
                                    cbForClose: function () {
                                        defer.resolve();
                                    }
                                });
                            } else {
                                auiDialog.warn('请选择业务类型、币种、签约主体、付款赎期相同的结算单', function () {
                                    defer.reject();
                                });
                            }
                        } else {
                            // 单条结算
                            inCurrencyList(multiple, {
                                cb: function () {
                                    auiSettlementService.confirmSettlementToOpenTrade(multiple, Model.billType, function () {
                                        //不刷新可以重复点击确认
                                        queryList();
                                        defer.resolve();
                                    }, false, Model.userInfo);
                                },
                                cbForClose: function () {
                                    defer.resolve();
                                }
                            });
                        }
                    }

                } else {
                    auiDialog.warn('请至少选择一条结算单', function () {
                        defer.reject();
                    });
                }
                return defer.promise;
            }


            function inCurrencyList(multiple, options) {
                //判断是否在cp商户服务支持的币种中，引导转至商户设置页面
                var currencyArr = '';
                if (mainCons.settlementConstant.signEntityBankMap[multiple.signEntityCode] === '0') {
                    if (!Model.bankInfoCN || !Model.bankInfoCN.bankName) {
                        auiDialog.confirm('您的境内收款账户信息不完善，请先维护账户信息', function () {
                            $state.go('mysetting.modBussnessInfo', {settlement: 'AccountSettlement'}, {reload: true});
                        }, function () {
                            options.cbForClose();
                        });
                    } else {
                        currencyArr = Model.bankInfoCN.currency.split(',');
                        openDlgForCurrency(currencyArr, options);
                    }

                } else {
                    if (!Model.bankInfoEN || !Model.bankInfoEN.bankName) {
                        auiDialog.confirm('您的跨境收款账户信息不完善，请先维护账户信息', function () {
                            $state.go('mysetting.modBussnessInfo', {settlement: 'AccountSettlement'}, {reload: true});
                        }, function () {
                            options.cbForClose();
                        });
                    } else {
                        currencyArr = Model.bankInfoEN.currency.split(',');
                        openDlgForCurrency(currencyArr, options);
                    }
                }
            }

            function openDlgForCurrency(currencyArr, options) {
                if (!AUI.BaseJSUtil.contains(currencyArr, Model.modifyList[0].currencyType)) {
                    myIncentiveService.dlgForCurrency(Model,options);
                } else {
                    options.cb();
                }
            }

            function applyDispute(bill) {
                var defer = $q.defer();
                auiSettlementService.applyDispute(bill, Model.billType, function () {
                    defer.resolve();
                }, Model.developerInfo);
                return defer.promise;
            }


            //获取用户开发者信息是否处于审核状态
            function getAudiState(userObj) {
                return !!(userObj && (userObj.updateRealState === 1 || userObj.verifyRealState === 1 || userObj.isChangeRealName === 1));
            }

            // 半选
            function checkHalf() {
                var result = auiSettlementService.checkHalf(Model.billList, Model.checked);

                // 是否所有的结算单都不能结算
                var unavaliable = Model.unavaliable;

                var disabled = $filter('auiUserInfoAvaliableFilter')(Model.billType, [$scope.cpInfoIsAuditing, $scope.businessInfoIsAuditing]);

                var half = result.temp != 0 && result.temp < result.listLength;

                if (disabled || unavaliable) {
                    return 'disabled'
                } else if (half) {
                    return 'half'
                }
            }

            // 全选
            function selectAll(event,flag) {
                event.stopPropagation();
                if(flag) return;
                Model.checked['all'] = (!Model.checked['all'])?true:false;
                var result = auiSettlementService.selectAll(Model.billList, Model.checked, Model.modifyList, Model.billType);
                Model.modifyList = result.modifyList;
                Model.checked = result.checked;
            }

            function selectSingle(bill, index,event,flag) {
                event.stopPropagation();
                if(flag) return;
                Model.checked[index] = (!Model.checked[index])?true:false;
                var result = auiSettlementService.selectSingle($filter('auiCheckListFilter')(Model.billList, Model.billType), Model.checked, Model.modifyList, bill, index);
                Model.modifyList = result.modifyList;
                Model.checked = result.checked;
            }


            //保存查询条件
            function saveQuery() {
                var query = {
                    selector: Model.selector,
                    billID: Model.query.billID,
                    batchNo:Model.query.batchNo,
                    queryTime: {
                        startTime: Model.timeQuarter.startTime,
                        endTime: Model.timeQuarter.endTime,
                        regionType: Model.timeQuarter.regionType //todo
                    }
                };
                sessionStorage.setItem("earningQuery", JSON.stringify(query));

            }

            //获取保存的查询条件
            function getQuery() {
                //如果是从确认结算单或者对账明细跳过来的，则按照上次的查询条件进行查询
                var query = JSON.parse(sessionStorage.getItem('earningQuery'));
                Model.timeQuarter.startTime = formatDate(query.queryTime.startTime);
                Model.timeQuarter.endTime = formatDate(query.queryTime.endTime);
                Model.timeQuarter.regionType = query.queryTime.regionType;
                Model.selector.businessTypeSelector = query.selector.businessTypeSelector;
                Model.selector.billStatusSelector = query.selector.billStatusSelector;
                Model.query.billID = query.billID;
                Model.query.batchNo=query.batchNo
            }

            //格式化日期
            function formatDate(dateStr) {
                var date = dateStr.slice(0, 7);
                date += '-01';
                return AUI.DateUtil.stringToDate(date);
            }

        }]);
});

